import { render, staticRenderFns } from "./heading.vue?vue&type=template&id=53f73466&scoped=true"
import script from "./heading.vue?vue&type=script&lang=js"
export * from "./heading.vue?vue&type=script&lang=js"
import style0 from "./heading.vue?vue&type=style&index=0&id=53f73466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f73466",
  null
  
)

export default component.exports